export function deleteAllSpaces(string: string): string {
  if (!string) {
    return '';
  }

  return string.replace(/\s+/g, '');
}
